import type { LeadFilter } from "@/types/entities";
import { useFilterUrlSync } from "@/hooks/useFilterUrlSync";
import { leadFilterUrlSyncConfig } from "./leadFilterParams";

/** Keeps the Leads list filter and the address-bar query string in lockstep. */
export function useLeadFilterUrlSync(
  filter: LeadFilter,
  setFilter: (next: Partial<LeadFilter>) => void,
  setSearch: (value: string) => void,
) {
  useFilterUrlSync(filter, setFilter, leadFilterUrlSyncConfig, {
    syncSearchInput: setSearch,
  });
}
